var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('button',{staticClass:"btn btn-success shadow-sm",on:{"click":function($event){return _vm.$emit('selected',_vm.seccion)}}},[_c('i',{staticClass:"fa fa-check fa-fw"})]),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.seccion.nombre))])])
}
var staticRenderFns = []

export { render, staticRenderFns }